import React, { useState, useEffect } from 'react';
import { SmallMatchBox } from "./smallMatchBox";
import { getStoredData } from "../utils/data-pulls";
import { displayErrorMessage, displayLoader } from '../utils';



/**
 * Grid of Matches
 */
const MatchGrid = (props) => {
    const { 
        date = null,
        competition = null,
        season = null,
        extraClasses = '',
        ...restProps 
    } = props;

    // Error and load handling
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    // List of matches to display
    const [ matches, setMatches ] = useState(null);
    
    // When we have a selected schedule date, competition, and season, get the corresponding matches
    useEffect(() => {
        if ( !date || !competition || !season ) return;
        setIsLoaded(false);

        // Turn date into something parseable by PHP
        const year = date.toLocaleString("default", { year: "numeric", timeZone: 'UTC' });
        const month = date.toLocaleString("default", { month: "2-digit", timeZone: 'UTC' });
        const day = date.toLocaleString("default", { day: "2-digit", timeZone: 'UTC' });
        const formattedDate = year + "-" + month + "-" + day;

        // Put together ajax arguments
        let args = [
            { 
                key: 'matches',
                type: 'specific',
                date: formattedDate,
                competition: competition,
                season: season
            }
        ];


        // Get our stored matches
        getStoredData(args).then(
            (result) => {

                // Set all matches
                if ( result.data.matches ) {
                    setMatches(result.data.matches);
                } else {
                    setMatches(null);
                }

                // Set loaded to true
                setIsLoaded(true);
                
            }
        ).catch(
            (error) => {
                setError(error);
            }
        );
        
    }, [ date, competition, season ]);


     // Bail if we don't have data yet
     if (!isLoaded ) {
        return displayLoader();
    }

    // Display an error message if there's a problem
    if ( error ) {
        console.log(error);
        return displayErrorMessage();
    }

    // Get the list of classes
    let classList = "acaScheduleGrid " + extraClasses;

    // Return the grid of matches
    return (
        <div className={classList}>
            
            { matches ? (
                matches.map((match, i) => (
                    <SmallMatchBox key={i} data={match} />
                ))
            ) : (
                <p><em>No matches on this day.</em></p>
            ) }
            
        </div>
    );
}

export { MatchGrid };
